import { createContext } from 'react';
import { EnvironmentVariables } from './types';

export const EnvironmentContext = createContext<EnvironmentVariables>(
  {} as EnvironmentVariables
);
